(function () {
  if (window.pgQuote) return;
  var LEGACY_KEY = 'pg_quote_v1';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = { item_count: 0, items: [] };

  function api(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function refresh() {
    return api('cart.js').then(function (c) {
      cart = c;
      paint();
      document.dispatchEvent(new CustomEvent('pg:cart', { detail: c }));
      return c;
    });
  }

  function inCart(handle) {
    return cart.items.some(function (i) { return i.handle === handle; });
  }

  function paint() {
    var n = cart.item_count || 0;
    document.querySelectorAll('[data-pg-qty]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-zero', n === 0);
    });
    document.querySelectorAll('[data-pg-in-quote]').forEach(function (b) {
      if (b.hasAttribute('data-stay')) return;
      var on = inCart(b.getAttribute('data-pg-in-quote'));
      b.classList.toggle('is-added', on);
      var lbl = b.querySelector('[data-lbl]');
      if (lbl) lbl.textContent = on ? 'In your cart' : (b.getAttribute('data-label') || 'Add to cart');
    });
  }

  function toast(msg, link) {
    var t = document.getElementById('pg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'pg-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    if (link) {
      var a = document.createElement('a');
      a.href = link;
      a.textContent = 'View cart';
      t.appendChild(a);
    }
    t.classList.add('is-on');
    clearTimeout(window.__pgT);
    window.__pgT = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  function variantFor(btn) {
    var id = btn.getAttribute('data-variant');
    if (id) return Promise.resolve(Number(id));
    var handle = btn.getAttribute('data-pg-add');
    return fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { return p.variants[0].id; });
  }

  function qtyFor(btn) {
    var ref = btn.getAttribute('data-qty-from');
    var input = ref ? document.getElementById(ref) : null;
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? Math.min(q, 99) : 1;
  }

  function add(btn) {
    var handle = btn.getAttribute('data-pg-add');
    var title = btn.getAttribute('data-title') || handle;

    if (!btn.hasAttribute('data-stay') && inCart(handle)) {
      window.location.href = root + 'pages/quote';
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    variantFor(btn)
      .then(function (id) { return api('cart/add.js', { items: [{ id: id, quantity: qtyFor(btn) }] }); })
      .then(refresh)
      .then(function () { toast(title + ' added to your cart. ', root + 'pages/quote'); })
      .catch(function (err) { toast((err && err.description) || 'That could not be added. Try again in a moment.'); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  function migrateLegacy() {
    var list;
    try { list = JSON.parse(localStorage.getItem(LEGACY_KEY)) || []; } catch (e) { list = []; }
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(function (i) {
      return fetch(root + 'products/' + i.h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var items = products.filter(Boolean).filter(function (p) { return !inCart(p.handle); })
        .map(function (p) { return { id: p.variants[0].id, quantity: 1 }; });
      try { localStorage.removeItem(LEGACY_KEY); } catch (e) {}
      if (items.length) return api('cart/add.js', { items: items });
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-pg-add]');
    if (btn) {
      e.preventDefault();
      add(btn);
      return;
    }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-qty-step'));
      input.value = Math.max(1, Math.min(99, next));
    }
  });

  function init() {
    refresh().then(function () { return migrateLegacy(); }).then(function () { return refresh(); }).catch(function () {});
  }

  window.pgQuote = { refresh: refresh, api: api, cart: function () { return cart; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', paint);
})();
